import { render, staticRenderFns } from "./Reopen.vue?vue&type=template&id=6c803d1d"
import script from "./Reopen.vue?vue&type=script&lang=js"
export * from "./Reopen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports